/* eslint-disable */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function SidebarIconGroup({
  children,
  className,
  flip,
  icon,
  id,
  isOpen,
  onClick,
  path,
  tooltip,
}) {
  const active = (id !== 'sb-signout' && window.location.pathname.includes(path));
  const navigate = useNavigate();

  return (
    <>
      <div
        id={id}
        className={`icon-group d-flex py-2 ${className || ''}`}
      >
        <div
          className="text-white d-flex align-items-center"
          onClick={() => (onClick ? onClick() : navigate(path))}
        >
          <div className={`highlight h-100 ${active ? 'active' : ''}`} />
          <div className="icon mx-2">
            <FontAwesomeIcon icon={icon} fixedWidth size="2x" flip={flip} />
          </div>
          <div className="label">
            {children}
          </div>
        </div>
      </div>
      {!isOpen && (
        <UncontrolledTooltip target={id} placement="right">
          {tooltip || children}
        </UncontrolledTooltip>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.sidebarOpen,
});

export default connect(mapStateToProps)(SidebarIconGroup);
